import React from 'react';
import { Avatar, Typography } from 'antd';
import cx from 'classnames';
import moment from 'moment';
import { DEFAULT_AVATAR } from '@gtintel/platform-constants';
import styles from './partnerCard.module.scss';
const {
  Text
} = Typography;
const PartnerCard = props => {
  const {
    avatar,
    name,
    timezone,
    color
  } = props;
  const timestamp = moment.tz(timezone).zoneAbbr() === 'GMT' ? '(GMT)' : `(GMT${moment.tz(timezone).zoneAbbr()})`;
  return <table className={cx('avatar-name', styles.container)}>
      <tbody>
        <tr>
          <td>
            <Avatar src={avatar ? avatar : DEFAULT_AVATAR} className="avatar" style={color ? {
            borderColor: color
          } : {}} />
          </td>
          <td>
            <div className={cx('name', styles.name)}>
              <Text>{name}</Text>
            </div>
            <div className={cx('role', styles.timezone)}>
              <Text>{timestamp}</Text>
            </div>
          </td>
        </tr>
      </tbody>
    </table>;
};
export default PartnerCard;